import { createSelector } from '@reduxjs/toolkit'

const sliceSelector = (state) => state.managedEventTypes.assign.memberships.groups

const isLoadingSelector = createSelector(
  sliceSelector,
  ({ status }) => status === 'loading' || status === 'initial'
)

const isLoadedSelector = createSelector(
  sliceSelector,
  ({ status }) => status === 'loaded'
)

export {
  isLoadingSelector,
  isLoadedSelector
}
